const GenerateBadge = (status) => {
  if (status.toUpperCase() === 'ACTIVE') {
    return 'success';
  }

  return 'error';
};

export default GenerateBadge;
